// import React from 'react';
import React, { useState,  forwardRef, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ProcessorList from './Management/processorlist';
import AdminList from './Management/adminlist';
import ExpertList from './Management/expertlist';
import GCodeList from './Management/gcodelist';
import ManufacturerList from './Management/manufacturerlist';
import PartnerList from './Management/partnerlist';
import ManuLocation from './Management/manuLocation';
import { AuthorizeContext } from "../RootContext";


const useStyles = makeStyles((theme) => ({
  page: {
    width: '100%',
    minHeight: 'calc(100vh - 72px)',
    padding: '18px 18px 48px',
    boxSizing: 'border-box',
    color: '#1f3747',
    fontFamily:
      '"Segoe UI Variable", "Segoe UI", Inter, -apple-system, BlinkMacSystemFont, Arial, sans-serif',
    background:
      'radial-gradient(circle at 7% 0%, rgba(27, 166, 170, 0.18) 0, transparent 29%), radial-gradient(circle at 94% 6%, rgba(55, 111, 186, 0.15) 0, transparent 31%), linear-gradient(180deg, #f7fbfc 0%, #e8f2f6 100%)',

    '& *, & *::before, & *::after': {
      boxSizing: 'border-box',
    },

    '& .MuiTypography-root, & .MuiTableCell-root, & .MuiInputBase-root, & .MuiButton-root, & .MuiTablePagination-root, & input, & select, & button': {
      fontFamily:
        '"Segoe UI Variable", "Segoe UI", Inter, -apple-system, BlinkMacSystemFont, Arial, sans-serif !important',
    },

    [theme.breakpoints.down('sm')]: {
      padding: '14px 10px 34px',
    },
  },

  shell: {
    width: '100%',
    maxWidth: 1640,
    margin: '0 auto',
  },

  listStack: {
    display: 'grid',
    gap: 20,
  },

  listCard: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    overflow: 'hidden',
    border: '1px solid #d5e5ea',
    borderTop: '4px solid #1495a4',
    borderRadius: 16,
    background: '#ffffff',
    boxShadow: '0 16px 38px rgba(25, 76, 99, 0.11)',

    '&:nth-child(2)': { borderTopColor: '#3f75b5' },
    '&:nth-child(3)': { borderTopColor: '#7a63b8' },
    '&:nth-child(4)': { borderTopColor: '#d38b2f' },
    '&:nth-child(5)': { borderTopColor: '#2f9b73' },
    '&:nth-child(6)': { borderTopColor: '#b25b7f' },
    '&:nth-child(7)': { borderTopColor: '#5b7f9d' },

    /* Force every legacy list component to use the same full-width alignment. */
    '& > div, & > div > div, & .App, & .MuiGrid-container, & .MuiGrid-root': {
      width: '100% !important',
      maxWidth: '100% !important',
      minWidth: '0 !important',
      marginLeft: '0 !important',
      marginRight: '0 !important',
      boxSizing: 'border-box !important',
    },

    '& .MuiGrid-item': {
      width: '100% !important',
      maxWidth: '100% !important',
      flexBasis: '100% !important',
      minWidth: '0 !important',
      paddingLeft: '0 !important',
      paddingRight: '0 !important',
    },

    '& .MuiPaper-root': {
      position: 'relative',
      width: '100% !important',
      maxWidth: '100% !important',
      minWidth: '0 !important',
      margin: '0 !important',
      borderRadius: '0 !important',
      boxShadow: 'none !important',
      background: '#ffffff !important',
    },

    '& .MuiToolbar-root': {
      minHeight: '70px !important',
      padding: '0 20px !important',
      borderBottom: '1px solid #d6e8ed',
      background: 'linear-gradient(90deg, #eef9fa 0%, #f2f7fc 100%)',
    },

    '& .MuiToolbar-root h6': {
      color: '#0f5365',
      fontSize: '20px !important',
      fontWeight: '800 !important',
      letterSpacing: '-0.015em',
    },

    '& .MuiToolbar-root .MuiInputBase-root': {
      minHeight: 44,
      padding: '0 11px',
      border: '1px solid #bfd8df',
      borderRadius: 9,
      background: '#ffffff',
      color: '#294355',
      boxShadow: '0 3px 10px rgba(24, 92, 111, 0.06)',
      fontSize: '15px',
    },

    '& .MuiInput-underline:before, & .MuiInput-underline:after': {
      display: 'none',
    },

    '& .MuiTableContainer-root': {
      width: '100% !important',
      maxWidth: '100% !important',
      minWidth: '0 !important',
      margin: '0 !important',
      overflowX: 'hidden !important',
    },

    '& .MuiTable-root': {
      width: '100% !important',
      maxWidth: '100% !important',
      minWidth: '0 !important',
      tableLayout: 'fixed !important',
      borderCollapse: 'collapse !important',
    },

    /* MaterialTable may inject fixed pixel widths. Removing the colgroup lets
       all columns share the available width and prevents the G-Code table
       from appearing narrower or offset. */
    '& .MuiTable-root colgroup': {
      display: 'none !important',
    },

    '& .MuiTableCell-root': {
      minWidth: '0 !important',
      maxWidth: 'none !important',
      paddingLeft: '11px !important',
      paddingRight: '11px !important',
      overflow: 'hidden',
      overflowWrap: 'normal',
      wordBreak: 'normal',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap !important',
    },

    '& .MuiTableCell-head': {
      paddingTop: '18px !important',
      paddingBottom: '18px !important',
      borderBottom: '1px solid #b8d7df !important',
      background: 'linear-gradient(180deg, #dff1f5 0%, #e9f3f8 100%) !important',
      color: '#0d3b4d !important',
      fontFamily:
        '"Segoe UI Semibold", "Segoe UI Variable", "Segoe UI", Arial, sans-serif !important',
      fontSize: '18px !important',
      fontWeight: '850 !important',
      lineHeight: '1.25 !important',
      letterSpacing: '0.012em',
      whiteSpace: 'normal !important',
      overflow: 'hidden',
      textOverflow: 'clip',
      textShadow: '0 0 0 currentColor',
    },

    '& .MuiTableCell-body': {
      paddingTop: '17px !important',
      paddingBottom: '17px !important',
      borderBottom: '1px solid #e5eef1 !important',
      color: '#263f4f',
      fontSize: '15px !important',
      lineHeight: '1.45 !important',
      fontWeight: '500 !important',
    },

    /* Keep email and username values on one line without allowing them to
       spill into the Password or neighboring columns. */
    '& .MuiTableCell-head:nth-child(3), & .MuiTableCell-body:nth-child(3)': {
      whiteSpace: 'nowrap !important',
      overflow: 'hidden !important',
      textOverflow: 'ellipsis !important',
    },

    /* Partners: Login Email is column seven. */
    '&:nth-child(4) .MuiTableCell-head:nth-child(7), &:nth-child(4) .MuiTableCell-body:nth-child(7)': {
      whiteSpace: 'nowrap !important',
      overflow: 'hidden !important',
      textOverflow: 'ellipsis !important',
    },

    /* Long partner street addresses may wrap inside their own column. */
    '&:nth-child(4) .MuiTableCell-head:nth-child(3), &:nth-child(4) .MuiTableCell-body:nth-child(3)': {
      whiteSpace: 'normal !important',
      overflowWrap: 'break-word',
      wordBreak: 'normal',
      lineHeight: '1.35 !important',
    },


    /* Processor column widths */
    '&:nth-child(1) .MuiTableCell-root:nth-child(1)': { width: '7% !important' },
    '&:nth-child(1) .MuiTableCell-root:nth-child(2)': { width: '7% !important' },
    '&:nth-child(1) .MuiTableCell-root:nth-child(3)': { width: '16% !important' },
    '&:nth-child(1) .MuiTableCell-root:nth-child(4)': { width: '7% !important' },
    '&:nth-child(1) .MuiTableCell-root:nth-child(5)': { width: '7% !important' },
    '&:nth-child(1) .MuiTableCell-root:nth-child(6)': { width: '7% !important' },
    '&:nth-child(1) .MuiTableCell-root:nth-child(7)': { width: '7% !important' },
    '&:nth-child(1) .MuiTableCell-root:nth-child(8)': { width: '6% !important' },
    '&:nth-child(1) .MuiTableCell-root:nth-child(9)': { width: '6% !important' },
    '&:nth-child(1) .MuiTableCell-root:nth-child(10)': { width: '6% !important' },
    '&:nth-child(1) .MuiTableCell-root:nth-child(11)': { width: '6% !important' },
    '&:nth-child(1) .MuiTableCell-root:nth-child(12)': { width: '7% !important' },
    '&:nth-child(1) .MuiTableCell-root:nth-child(13)': { width: '11% !important' },

    /* Expert column widths */
    '&:nth-child(2) .MuiTableCell-root:nth-child(1)': { width: '11% !important' },
    '&:nth-child(2) .MuiTableCell-root:nth-child(2)': { width: '11% !important' },
    '&:nth-child(2) .MuiTableCell-root:nth-child(3)': { width: '24% !important' },
    '&:nth-child(2) .MuiTableCell-root:nth-child(4)': { width: '10% !important' },
    '&:nth-child(2) .MuiTableCell-root:nth-child(5)': { width: '12% !important' },
    '&:nth-child(2) .MuiTableCell-root:nth-child(6)': { width: '12% !important' },
    '&:nth-child(2) .MuiTableCell-root:nth-child(7)': { width: '20% !important' },

    /* G-Code column widths */
    '&:nth-child(3) .MuiTableCell-root:nth-child(1)': { width: '12% !important' },
    '&:nth-child(3) .MuiTableCell-root:nth-child(2)': { width: '12% !important' },
    '&:nth-child(3) .MuiTableCell-root:nth-child(3)': { width: '26% !important' },
    '&:nth-child(3) .MuiTableCell-root:nth-child(4)': { width: '12% !important' },
    '&:nth-child(3) .MuiTableCell-root:nth-child(5)': { width: '14% !important' },
    '&:nth-child(3) .MuiTableCell-root:nth-child(6)': { width: '24% !important' },

    /* Partners column widths - UI only. Keep every visible heading/value inside
       the table without clipping the right-most Access Manufacturing column. */
    '&:nth-child(4) .MuiTableCell-root:nth-child(1)': { width: '8% !important' },
    '&:nth-child(4) .MuiTableCell-root:nth-child(2)': { width: '6% !important' },
    '&:nth-child(4) .MuiTableCell-root:nth-child(3)': { width: '15% !important' },
    '&:nth-child(4) .MuiTableCell-root:nth-child(4)': { width: '7% !important' },
    '&:nth-child(4) .MuiTableCell-root:nth-child(5)': { width: '6% !important' },
    '&:nth-child(4) .MuiTableCell-root:nth-child(6)': { width: '6% !important' },
    '&:nth-child(4) .MuiTableCell-root:nth-child(7)': { width: '17% !important' },
    '&:nth-child(4) .MuiTableCell-root:nth-child(8)': { width: '7% !important' },
    '&:nth-child(4) .MuiTableCell-root:nth-child(9)': { width: '8% !important' },
    '&:nth-child(4) .MuiTableCell-root:nth-child(10)': { width: '9% !important' },
    '&:nth-child(4) .MuiTableCell-root:nth-child(11)': { width: '11% !important' },

    /* Partners-only typography/wrapping so all headings remain readable. */
    '&:nth-child(4) .MuiTableCell-head': {
      paddingLeft: '8px !important',
      paddingRight: '8px !important',
      fontSize: '15px !important',
      lineHeight: '1.2 !important',
      whiteSpace: 'normal !important',
      overflow: 'visible !important',
      textOverflow: 'clip !important',
      wordBreak: 'normal !important',
      overflowWrap: 'break-word !important',
    },

    '&:nth-child(4) .MuiTableCell-body': {
      paddingLeft: '8px !important',
      paddingRight: '8px !important',
      fontSize: '14px !important',
    },

    '&:nth-child(4) .MuiTableCell-head:nth-child(9), &:nth-child(4) .MuiTableCell-body:nth-child(9), &:nth-child(4) .MuiTableCell-head:nth-child(10), &:nth-child(4) .MuiTableCell-body:nth-child(10), &:nth-child(4) .MuiTableCell-head:nth-child(11), &:nth-child(4) .MuiTableCell-body:nth-child(11)': {
      textAlign: 'center !important',
    },

    /* Manufacturers column widths */
    '&:nth-child(6) .MuiTableCell-root:nth-child(1)': { width: '8% !important' },
    '&:nth-child(6) .MuiTableCell-root:nth-child(2)': { width: '8% !important' },
    '&:nth-child(6) .MuiTableCell-root:nth-child(3)': { width: '18% !important' },
    '&:nth-child(6) .MuiTableCell-root:nth-child(4)': { width: '8% !important' },
    '&:nth-child(6) .MuiTableCell-root:nth-child(5)': { width: '10% !important' },
    '&:nth-child(6) .MuiTableCell-root:nth-child(6)': { width: '8% !important' },
    '&:nth-child(6) .MuiTableCell-root:nth-child(7)': { width: '7% !important' },
    '&:nth-child(6) .MuiTableCell-root:nth-child(8)': { width: '8% !important' },
    '&:nth-child(6) .MuiTableCell-root:nth-child(9)': { width: '8% !important' },
    '&:nth-child(6) .MuiTableCell-root:nth-child(10)': { width: '10% !important' },
    '&:nth-child(6) .MuiTableCell-root:nth-child(11)': { width: '7% !important' },

    /* Experts: align row checkmarks/dashes with the filter boxes. */
    '&:nth-child(2) .MuiTableCell-body:nth-child(5), &:nth-child(2) .MuiTableCell-body:nth-child(6)': {
      textAlign: 'center !important',
    },

    '&:nth-child(2) .MuiTableCell-body:nth-child(5) > div, &:nth-child(2) .MuiTableCell-body:nth-child(6) > div': {
      width: '100% !important',
      display: 'flex !important',
      alignItems: 'center !important',
      justifyContent: 'center !important',
      margin: '0 auto !important',
    },

    /* Manufacturers: align row checkmarks/dashes with the filter boxes. */
    '&:nth-child(6) .MuiTableCell-body:nth-child(7), &:nth-child(6) .MuiTableCell-body:nth-child(8), &:nth-child(6) .MuiTableCell-body:nth-child(9), &:nth-child(6) .MuiTableCell-body:nth-child(11)': {
      textAlign: 'center !important',
    },

    '&:nth-child(6) .MuiTableCell-body:nth-child(7) > div, &:nth-child(6) .MuiTableCell-body:nth-child(8) > div, &:nth-child(6) .MuiTableCell-body:nth-child(9) > div, &:nth-child(6) .MuiTableCell-body:nth-child(11) > div': {
      width: '100% !important',
      display: 'flex !important',
      alignItems: 'center !important',
      justifyContent: 'center !important',
      margin: '0 auto !important',
    },


    /* Administrators: center the Available filter box and each row's
       checkmark/dash on the exact same vertical line. */
    '&:nth-child(5) .MuiTableCell-head:nth-child(5), &:nth-child(5) .MuiTableCell-body:nth-child(5)': {
      textAlign: 'center !important',
    },

    '&:nth-child(5) .MuiTableHead-root .MuiTableRow-root:nth-child(2) .MuiTableCell-head:nth-child(5) > div, &:nth-child(5) .MuiTableCell-body:nth-child(5) > div': {
      width: '100% !important',
      display: 'flex !important',
      alignItems: 'center !important',
      justifyContent: 'center !important',
      margin: '0 auto !important',
    },

    '&:nth-child(5) .MuiTableHead-root .MuiTableRow-root:nth-child(2) .MuiTableCell-head:nth-child(5) .MuiCheckbox-root': {
      margin: '0 auto !important',
    },

    /* Keep the Actions heading on one line and give the Actions column enough
       room in both standard tables and the Partners table. */
    '& .MuiTableCell-head:last-child': {
      width: '118px !important',
      minWidth: '118px !important',
      maxWidth: '118px !important',
      whiteSpace: 'nowrap !important',
      textAlign: 'center !important',
    },

    '& .MuiTable-root:has(.MuiTableCell-head:nth-child(11)) .MuiTableCell-head:nth-last-child(2)': {
      width: '118px !important',
      minWidth: '118px !important',
      maxWidth: '118px !important',
      whiteSpace: 'nowrap !important',
      textAlign: 'center !important',
    },

    /* Partners overrides: keep Actions and Access Manufacturing fully inside
       the table instead of forcing fixed pixel widths. */
    '&:nth-child(4) .MuiTableCell-head:nth-child(10), &:nth-child(4) .MuiTableCell-body:nth-child(10)': {
      width: '9% !important',
      minWidth: '0 !important',
      maxWidth: 'none !important',
      whiteSpace: 'nowrap !important',
      textAlign: 'center !important',
    },

    '&:nth-child(4) .MuiTableCell-head:nth-child(11), &:nth-child(4) .MuiTableCell-body:nth-child(11)': {
      width: '11% !important',
      minWidth: '0 !important',
      maxWidth: 'none !important',
      whiteSpace: 'normal !important',
      textAlign: 'center !important',
      overflow: 'visible !important',
      textOverflow: 'clip !important',
    },

    /* Center any cell that contains the MaterialTable action buttons. This
       fixes the Partners action icons without shifting other data columns. */
    '& .MuiTableCell-body:has(.MuiIconButton-root)': {
      textAlign: 'center !important',
      whiteSpace: 'nowrap !important',
    },

    '& .MuiTableCell-body:has(.MuiIconButton-root) > div': {
      width: '100% !important',
      display: 'flex !important',
      alignItems: 'center !important',
      justifyContent: 'center !important',
      flexWrap: 'nowrap !important',
      gap: '2px',
      margin: '0 auto !important',
    },

    '& .MuiTableCell-body:has(.MuiIconButton-root) .MuiIconButton-root': {
      flex: '0 0 auto',
      margin: '0 1px !important',
    },


    /* Center the filter-row controls directly beneath their column headings.
       This fixes the square checkbox/filter controls appearing pushed right. */
    '& .MuiTableHead-root .MuiTableRow-root:nth-child(2) .MuiTableCell-head': {
      textAlign: 'center !important',
      verticalAlign: 'middle !important',
    },

    '& .MuiTableHead-root .MuiTableRow-root:nth-child(2) .MuiTableCell-head > div': {
      width: '100% !important',
      minWidth: '0 !important',
      display: 'flex !important',
      alignItems: 'center !important',
      justifyContent: 'center !important',
      margin: '0 auto !important',
      padding: '0 !important',
    },

    '& .MuiTableHead-root .MuiTableRow-root:nth-child(2) .MuiCheckbox-root, & .MuiTableHead-root .MuiTableRow-root:nth-child(2) .MuiIconButton-root': {
      margin: '0 auto !important',
      padding: '6px !important',
    },

    '& .MuiTableHead-root .MuiTableRow-root:nth-child(2) .MuiInputBase-root': {
      width: '100% !important',
      margin: '0 auto !important',
    },


    /* G-Code and Manufacturing Mapping: place the Available filter box on
       the same vertical line as the row checkmarks/dashes. */
    '&:nth-child(3) .MuiTableHead-root .MuiTableRow-root:nth-child(2) .MuiTableCell-head:nth-child(5), &:nth-child(7) .MuiTableHead-root .MuiTableRow-root:nth-child(2) .MuiTableCell-head:nth-child(5)': {
      textAlign: 'left !important',
    },

    '&:nth-child(3) .MuiTableHead-root .MuiTableRow-root:nth-child(2) .MuiTableCell-head:nth-child(5) > div, &:nth-child(7) .MuiTableHead-root .MuiTableRow-root:nth-child(2) .MuiTableCell-head:nth-child(5) > div': {
      width: '100% !important',
      display: 'flex !important',
      alignItems: 'center !important',
      justifyContent: 'flex-start !important',
      margin: '0 !important',
      padding: '0 !important',
    },

    '&:nth-child(3) .MuiTableHead-root .MuiTableRow-root:nth-child(2) .MuiTableCell-head:nth-child(5) .MuiCheckbox-root, &:nth-child(7) .MuiTableHead-root .MuiTableRow-root:nth-child(2) .MuiTableCell-head:nth-child(5) .MuiCheckbox-root': {
      margin: '0 !important',
      padding: '6px !important',
    },

    '&:nth-child(3) .MuiTableCell-body:nth-child(5), &:nth-child(7) .MuiTableCell-body:nth-child(5)': {
      textAlign: 'left !important',
    },

    '& .MuiTableRow-root': {
      transition: 'background-color 130ms ease',
    },

    '& .MuiTableRow-root:nth-of-type(even) .MuiTableCell-body': {
      background: '#f7fbfc',
    },

    '& .MuiTableRow-root:hover .MuiTableCell-body': {
      background: '#e7f5f8 !important',
    },

    '& .MuiIconButton-root': {
      padding: '6px !important',
      color: '#317285',
      transition: 'background-color 130ms ease, color 130ms ease, transform 130ms ease',
    },

    '& .MuiIconButton-root:hover': {
      color: '#075f75',
      background: '#dff1f5',
      transform: 'translateY(-1px)',
    },

    '& .MuiSvgIcon-root': {
      fontSize: '21px !important',
    },

    /* Keep the row-count and page controls visible at the bottom-right of
       every table, even when a legacy table has a wider scrollable body. */
    '& .MuiTableFooter-root': {
      position: 'sticky !important',
      left: '0 !important',
      right: '0 !important',
      zIndex: 7,
      background: '#f8fbfc',
    },

    '& .MuiTableFooter-root .MuiTableRow-root': {
      position: 'sticky !important',
      left: '0 !important',
      right: '0 !important',
      zIndex: 7,
      background: '#f8fbfc',
    },

    '& .MuiTablePagination-root': {
      position: 'sticky !important',
      left: '0 !important',
      right: '0 !important',
      zIndex: 8,
      width: '100% !important',
      minWidth: '100% !important',
      maxWidth: '100% !important',
      overflow: 'visible !important',
      borderTop: '1px solid #d9e8ec',
      color: '#476979',
      background: '#f8fbfc',
    },

    '& .MuiTablePagination-toolbar': {
      position: 'sticky !important',
      right: '0 !important',
      left: 'auto !important',
      width: 'fit-content !important',
      maxWidth: '100% !important',
      minHeight: '64px !important',
      marginLeft: 'auto !important',
      padding: '0 14px !important',
      flexWrap: 'nowrap !important',
      background: '#f8fbfc',
    },

    '& .MuiTablePagination-spacer': {
      display: 'none !important',
    },

    '& .MuiTablePagination-caption, & .MuiTablePagination-select': {
      fontSize: '14px !important',
      fontWeight: '650 !important',
    },

    '& .MuiCheckbox-root': {
      color: '#6d8593',
    },

    '& .MuiCheckbox-colorSecondary.Mui-checked': {
      color: '#1495a4',
    },

    '& .MuiSelect-icon': {
      color: '#3d7484',
    },
  },

  emptyState: {
    padding: '34px 24px',
    border: '1px solid #d8e5ea',
    borderRadius: 16,
    background: '#ffffff',
    color: '#6c8290',
    fontSize: 15,
    textAlign: 'center',
    boxShadow: '0 12px 30px rgba(23, 70, 94, 0.07)',
  },
}));


const UserManagePage = () => {
   const classes = useStyles();
   const { token, authBody, setAuthenticated, setAuthBody } = useContext(AuthorizeContext);
  const [data, setData] = useState({});
  // let { hospitalID } = useParams();

  const [profile, setProfile] = useState(authBody || {role: "visitor"})
  const hasRole = (profile, roles) =>{
    return roles.includes(profile.role)
  }
  console.log(profile)

  return(
    <>    
    <main className={classes.page}>
      <div className={classes.shell}>
    {
      hasRole(profile, ['super_admin', 'write_admin', 'read_admin']) && 
      <div>
        <div className={classes.listStack}>
          <section className={classes.listCard}>
    <ManufacturerList />
          </section>
          <section className={classes.listCard}>
    <ProcessorList />
          </section>
          <section className={classes.listCard}>
    <ExpertList />
          </section>
          <section className={classes.listCard}>
    <GCodeList />
          </section>
          <section className={classes.listCard}>
    <PartnerList/>
          </section>
          <section className={classes.listCard}>
    <AdminList />
          </section>
        {/*  <section className={classes.listCard}>
    <ManuLocation/>
          </section>
          */}
        </div>
      </div>
    }
    {
      hasRole(profile, ['partner_admin']) && profile.manu_given === true ?
      <div>
        <div className={classes.listStack}>
          <section className={classes.listCard}>
    <ManufacturerList />
          </section>
        </div>
      </div>
      :
      <div></div>
    }
      </div>
    </main>
    </>
  )
};

export default UserManagePage;